import Vue from 'vue';
import {API_ROOT} from '../config'

const customActions = {
  deactivate: {method: 'PUT', url: API_ROOT + 'area{/id}/deactivate'},
  activate: {method: 'PUT', url: API_ROOT + 'area{/id}/activate'}
};

export default Vue.resource(API_ROOT + 'area{/id}', {}, customActions);



// WEBPACK FOOTER //
// ./client/resources/areaResource.js